import { email } from "@/core/validation"
import { object, string, array, boolean } from "yup"

export default object({
  name: string().required("Required"),
  owner: string().required("Required"),
  url: string().required("Required"),
  catchAll: email,
  // Permission fields
  fullAccessUsers: array().of(string()),
  editAccessUsers: array().of(string()),
  editAccessPages: array().of(string()),
  readAccessUsers: array().of(string()),
  readAccessPages: array().of(string()),
  specialPermissions: object({
    dncListEdit: boolean().nullable(),
  }).nullable(),
})
